module.exports = __webpack_public_path__ + "img/1.50729dd9.jpg";